<script lang="tsx">
import { defineComponent, toRef, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { FormItem } from '-/Common/Form'
import { InputRmb } from '-/Common/Input'
import { getRequiredRule } from '@/constant/form'
const [name] = createNamespace('SelfBuildTownResettleStandardForm')

export default defineComponent({
  name,
  props: {
    dataSync: {
      type: Object as PropType<Partial<ApiJtProj.ResettleStandardData>>
    }
  },
  setup(props) {
    const data = toRef(props, 'dataSync', {})
    return () => (
      <div class='ant-row-form-item'>
        政策补助。按
        <FormItem name='tongGuiZiJianAnZhiXiangZhen' rules={getRequiredRule('政策补助标准')}>
          <InputRmb v-model:value={data.value.tongGuiZiJianAnZhiXiangZhen} style='width: 150px' addonAfter='元/人' />
        </FormItem>
        （包括搬迁奖励、建房补助及过渡费）标准执行。
      </div>
    )
  }
})
</script>
